import { useIntl } from 'react-intl'
import { connect } from 'react-redux'
import './NewsMainInfo.scss'
import { LuxMultiSelect, LuxRichInputText, LuxSelect } from '@lux/wardrobe-lib'
import SectionItem from '@components/Layout/SectionItem/SectionItem'
import ProjectCover from '@/app/components/ActivityCreation/MainInfo/ProjectCover/ProjectCover'
import ProjectTitle from '@/app/components/ActivityCreation/MainInfo/ProjectTitle/ProjectTitle'
import AddAttachment from '@components/UI/AddAttachment/AddAttachment'
import MessagingOptions from '@/app/components/ActivityCreation/MainInfo/MessagingOptions/MessagingOptions'
import SectionItemContainer from '@components/Layout/SectionItemContainer/SectionItemContainer'
import { FormBase, NewsMainInfoForm } from '@models/new-activity-form'
import { newsForm } from '@/app/models/new-activity-news-form'
import { NewActivitySectionType } from '@/app/models/new-activity-section-type'
import { FILTERS_REDUCER_NAMESPACE } from '@/app/redux/reducers/filters'
import { ProjectsService } from '@/app/services/ProjectsService'

const NewsMainInfo = (props: FormBase<NewsMainInfoForm>) => {
    const componentClass = 'smart-new-activity-news-main-info'
    const intl = useIntl()
    const { form, onSetForm, onSave, isDone, departmentList, recipientList } = props

    const onUpload = (files) => {
        onSetForm({
            ...form,
            attachmentList: {
                value: [
                    ...form.attachmentList.value,
                    ...files.map((file: any) => ({
                        fileBlob: file.file,
                        file: file.file,
                        url: file.url,
                        id: file.id,
                    })),
                ],
            },
        })
    }

    const onRemoveAttachment = (file) => {
        let newList = [...form.attachmentList.value]
        const fileIndex = newList.findIndex((i) => i.file.name === file.name)
        newList.splice(fileIndex, 1)
        onSetForm({
            ...form,
            attachmentList: {
                value: [...newList],
            },
        })
    }

    return (
        <SectionItemContainer
            hideFooter={true}
            onSave={() => onSave()}
            onClear={() => onSetForm({ ...newsForm[NewActivitySectionType.MAIN_INFO] })}
            isDone={isDone}>
            <SectionItem>
                <ProjectCover form={form} onSave={(form) => onSetForm(form)} />
            </SectionItem>
            <SectionItem>
                <ProjectTitle form={form} onSetForm={(form) => onSetForm(form)}>
                    <div className={`${componentClass}__input-wrapper`}></div>
                    <div className="flex flex-col gap-2">
                        <LuxSelect
                            value={form.department.value}
                            disabled={form.department.disabled}
                            onChangeCallback={(value) =>
                                onSetForm({ ...form, department: { ...form.department, value } })
                            }
                            colWidth={6}
                            mandatory={form.department.mandatory}
                            label={intl.formatMessage({
                                id: 'modals.new.activity.section.main.info.select.department',
                                defaultMessage: 'Select department',
                            })}
                            options={departmentList.map((department) => ({
                                ...department,
                                label: intl.formatMessage({
                                    id: department.label,
                                    defaultMessage: department.label.split('.').pop(),
                                }),
                            }))}
                            placeholder={intl.formatMessage({
                                id: 'modals.new.activity.section.main.info.select.department',
                                defaultMessage: 'Select department',
                            })}
                            additionalProps={{
                                appendTo: 'self',
                            }}
                        />
                        <LuxMultiSelect
                            value={form.recipient.value}
                            disabled={form.recipient.disabled}
                            onChangeCallback={(value) =>
                                onSetForm({ ...form, recipient: { ...form.recipient, value } })
                            }
                            colWidth={6}
                            mandatory={form.recipient.mandatory}
                            label={intl.formatMessage({
                                id: 'modals.new.activity.section.main.info.select.recipient',
                                defaultMessage: 'Select recipient',
                            })}
                            options={recipientList.map((recipient) => ({
                                ...recipient,
                                label: intl.formatMessage({
                                    id: recipient.label,
                                    defaultMessage: recipient.label.split('.').pop(),
                                }),
                            }))}
                            additionalProps={{
                                appendTo: 'self',
                            }}
                            placeholder={intl.formatMessage({
                                id: 'modals.new.activity.section.main.info.select.recipient',
                                defaultMessage: 'Select recipient',
                            })}
                        />
                    </div>
                </ProjectTitle>
            </SectionItem>
            <div className={`${componentClass}__field-container`}>
                <LuxRichInputText
                    value={form.info.value}
                    onChangeCallback={(value: string) => onSetForm({ ...form, info: { value } })}
                    placeholder={intl.formatMessage({
                        id: 'modals.new.activity.section.main.info.rich.text.input.placeholder',
                        defaultMessage: 'Type here',
                    })}
                    label={intl.formatMessage({
                        id: 'modals.new.activity.section.main.info.rich.text.input.label',
                        defaultMessage: 'Information',
                    })}
                    config={{
                        events: {
                            initialized() {
                                const editor = this
                                if (form.info.disabled) editor.edit.off()
                            },
                        },
                    }}
                    fileUploadUrl={ProjectsService.FROALA_UPLOAD_URL}
                />
            </div>
            <div className={`${componentClass}__field-container`}>
                <AddAttachment
                    id={'news-main-info'}
                    form={form}
                    onUpload={(form) => onUpload(form)}
                    showRemoveIcon
                    onRemove={(file) => onRemoveAttachment(file)}
                    showSplitFile
                    disabled={form.attachmentList.disabled}
                />
            </div>
            <MessagingOptions
                enableCommentReaction
                disableDisclaimer
                form={form}
                onSetForm={(form) => onSetForm(form)}
            />
        </SectionItemContainer>
    )
}

const mapStateToProps = (state: any) => ({
    departmentList: state[FILTERS_REDUCER_NAMESPACE].departmentList,
    recipientList: state[FILTERS_REDUCER_NAMESPACE].recipientList,
})

const mapDispatchToProps = (dispatch: any) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(NewsMainInfo)
